if (!customElements.get('password-input')) {

  class passwordInput extends HTMLElement {
    constructor() {
      super();
      
      this.button = this.querySelector('button[data-action="switch-password"]');
      this.input = this.querySelector('input[type="password"]');
    }
    
    connectedCallback() {
      if (!this.button) return;
      
      this.button.addEventListener('click', () => {
        let currentIcon = this.button.querySelector('span:not(.hidden)');
        this.button.querySelector('span.hidden').classList.remove('hidden');
        currentIcon.classList.add('hidden');
        
        if (this.input.type == 'password') {
          this.input.type = "text";
        } else {
          this.input.type = "password";
        }
      });
    }
  }
  
  customElements.define('password-input', passwordInput);
}